module.exports = __webpack_public_path__ + "img/terroir-bright-4.269fb24b.jpg";